import { render, staticRenderFns } from "./SpacerBox.vue?vue&type=template&id=b2734bf2&scoped=true&"
import script from "./SpacerBox.vue?vue&type=script&lang=ts&"
export * from "./SpacerBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2734bf2",
  null
  
)

export default component.exports